import React from 'react';
import { Link } from 'react-router-dom';
import MatrixRain from './MatrixRain';
import LiveCounter from './LiveCounter';
import { useTheme } from '../ThemeContext';

const HeroSection = () => {
  const { isInstitutional } = useTheme();
  return (
  <section data-testid="hero-section" className="min-h-screen flex items-center justify-center relative overflow-hidden">
    <MatrixRain opacity={0.07} speed={0.8} />
    <div className="absolute inset-0 bg-gradient-to-b from-transparent via-transparent to-[#050505]" />
    
    <div className="relative z-10 text-center px-6 max-w-5xl mx-auto pt-36 md:pt-32">
      
      {/* H1 SEO — unico per pagina */}
      <h1 className="sr-only">&lt;/AI_covo.tech&gt; | Cooperativa Sociale &amp; Digital Hub a Colle di Val d'Elsa — La sapienza di ieri nel cloud di domani</h1>

      {/* Nicklogo < / */}
      <p className="font-mono font-black text-5xl md:text-7xl text-[#00FF41] mb-1 animate-fade-in-up whitespace-nowrap" style={{ textShadow: '0 0 30px rgba(0,255,65,0.3)', letterSpacing: '0.05em' }} data-testid="hero-nicklogo" aria-hidden="true">&lt;/</p>
      <p className="font-mono text-[10px] md:text-xs font-black uppercase tracking-[0.3em] mb-6 animate-fade-in-up">
        <span className="wave-text wave-text-slow">
          {'DIGITAL HUB SOCIALE'.split('').map((char, i) => (
            <span key={i} style={{ color: '#fff', textShadow: '0 0 10px rgba(255,255,255,0.5)' }}>{char === ' ' ? '\u00A0' : char}</span>
          ))}
        </span>
      </p>

      <h2 className="sr-only">L'Intelligenza Artificiale alla portata di tutti — Doposcuola, Formazione, Workshop, Sportello Psicologico</h2>

      <div className="text-lg md:text-xl max-w-4xl mx-auto mb-4 leading-relaxed animate-fade-in-up stagger-2">
        <div className="flex flex-wrap justify-center gap-3 mb-3">
          <Link to="/doposcuola" className="zanfa-cta" data-testid="hero-cta-doposcuola">&lt;/doposcuola_sport&gt;</Link>
          <Link to="/formazione" className="zanfa-cta" data-testid="hero-cta-academy">&lt;/stage_r€tribuiti&gt;</Link>
          <Link to="/formazione" className="zanfa-cta" data-testid="hero-cta-formazione">&lt;/formazione_digitale&gt;</Link>
          <Link to="/formazione" className="zanfa-cta" data-testid="hero-cta-prompt" style={{borderColor: '#FF4444', color: '#FF4444'}}>&lt;/prompt_chi_parla?&gt;</Link>
        </div>
        <div className="flex flex-wrap justify-center gap-3">
          <Link to="/sede" className="zanfa-cta" data-testid="hero-cta-spazi">&lt;/spazi_pubblici&gt;</Link>
          <Link to="/hub" className="zanfa-cta" data-testid="hero-cta-inclusione">&lt;/inclusione&gt;</Link>
          <Link to="/cittadino" className="zanfa-cta" data-testid="hero-cta-cittadino">&lt;/cittadino&gt;</Link>
          <Link to="/mentor" className="zanfa-cta" data-testid="hero-cta-mentor">&lt;/mentore&gt;</Link>
        </div>
        <p className="mt-4 mb-1">
          <span className="wave-text wave-text-slow" style={{ fontFamily: "'Georgia', serif", fontWeight: 700, fontStyle: 'italic', fontSize: '13px' }}>
            {'voglio sapere per fare, fare per sapere'.split('').map((c, i) => (
              <span key={i} style={{ color: '#fff' }}>{c === ' ' ? '\u00A0' : c}</span>
            ))}
          </span>
        </p>
        <p className="font-mono text-[9px] uppercase tracking-[0.2em] mb-2 font-bold" style={{ color: '#FFFFFF' }}>la conoscenza per tutti, dappertutto</p>
      </div>
      <div className="flex flex-col items-center gap-4 mb-16 animate-fade-in-up stagger-2">
        <p className="text-[9px] font-mono uppercase tracking-[0.4em] text-center mb-3 font-bold" style={{ color: '#FFFFFF' }} data-testid="hero-sponsored-by-label">Sponsored By</p>
        <a href="https://www.schedabusiness.com" target="_blank" rel="noopener noreferrer"
          className="group block transition-all duration-300 hover:scale-105"
          data-testid="hero-sponsor-sbp"
        >
          <p className="text-center font-black italic" style={{ fontSize: 'clamp(26px, 4vw, 42px)', color: '#D4A843', fontFamily: "'Poppins', 'Arial Black', sans-serif", lineHeight: 1.1, letterSpacing: '-0.5px' }}>schedabusiness.com</p>
          <p className="text-center mt-2">
            <span className="wave-text" style={{ fontFamily: "'Georgia', serif", fontWeight: 700, fontStyle: 'italic', fontSize: '14px' }}>
              {'se non ti trovano, non esisti'.split('').map((char, i) => (
                <span key={i} style={{ color: '#fff' }}>{char === ' ' ? '\u00A0' : char}</span>
              ))}
            </span>
          </p>
        </a>
        <a href="https://aicovo.tech/roadmap" target="_blank" rel="noopener noreferrer" className="inline-block font-mono text-xs text-[#00FF41] hover:text-white transition-colors mt-2 underline underline-offset-4" style={{ textShadow: '0 0 6px rgba(0,255,65,0.3)' }} data-testid="hero-roadmap-link">
          aicovo.tech/roadmap
        </a>
        <p className="font-mono text-[8px] md:text-[10px] font-black uppercase tracking-[0.25em] leading-none text-center sbp-shimmer-text mt-3">
          VISIONARI IN MISSIONE
        </p>
        <style>{`
          .sbp-shimmer-text {
            background: linear-gradient(90deg, #3B2506 0%, #5C3A0E 30%, #FFD89B 48%, #FFECD2 50%, #FFD89B 52%, #5C3A0E 70%, #3B2506 100%);
            background-size: 200% 100%;
            -webkit-background-clip: text;
            -webkit-text-fill-color: transparent;
            background-clip: text;
            animation: sbpShimmer 3s ease-in-out infinite;
          }
          @keyframes sbpShimmer {
            0% { background-position: 200% center; }
            100% { background-position: -200% center; }
          }
        `}</style>
      </div>

      <div className="animate-fade-in-up stagger-2">
        <LiveCounter />
      </div>
      
      <div className="flex flex-col sm:flex-row gap-4 justify-center animate-fade-in-up stagger-3">
        <Link to="/hub" data-testid="hero-cta-hub" className="btn-primary bg-[#00FF41] text-black border-[#00FF41] hover:bg-[#33FF66] font-mono font-bold">
          &lt;/ Scopri il Progetto
        </Link>
        <a href="mailto:riccardorossi1984@gmail.com?subject=Info%20Progetto%20AI_COVO" data-testid="hero-cta-contattaci" className="btn-primary">
          Contattaci
        </a>
      </div>
    </div>

    <div className="absolute bottom-8 left-1/2 -translate-x-1/2 animate-bounce">
      <svg className="w-6 h-6 text-zinc-600" fill="none" stroke="currentColor" viewBox="0 0 24 24">
        <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2} d="M19 14l-7 7m0 0l-7-7m7 7V3" />
      </svg>
    </div>
  </section>
  );
};

export default HeroSection;
